import { render, staticRenderFns } from "./importacionAdd.vue?vue&type=template&id=8c6380e0"
import script from "./importacionAdd.vue?vue&type=script&lang=js"
export * from "./importacionAdd.vue?vue&type=script&lang=js"
import style0 from "./importacionAdd.vue?vue&type=style&index=0&id=8c6380e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports